module.exports = __webpack_public_path__ + "img/Smurfit Kappa.4127ae74.jpg";